import {Button, Modal} from "antd";
import React, {memo, FC, useState} from "react";
import {FormikProps} from "formik";
import css from "./LessonBookings.less";
import ModalContainer from "./ModalContainer";
import {PossibleFormikPropsType} from "../CourseCreate/CourseCreateForm";
import {GetBookingsByCourseIdWithCourseLessonBookingsQuery} from "../../../generated/graphql";
import ModifyBookingsDocumentation from "./ModifyBookingsDocumentation/ModifyBookingsDocumentation";
import ModifyBookingsModalTitle from "./ModifyBookingsModalTitle";

type ModifyBookingsModalProps = {
    courseId: string;
    courseNumber?: string;
    formikProps: FormikProps<PossibleFormikPropsType>;
    bookingsOfCourse?: GetBookingsByCourseIdWithCourseLessonBookingsQuery["bookingsByCourseIdWithCourseLessonBookings"];
    lessonsAreChanged: boolean;
};

const ModifyBookingsModal: FC<ModifyBookingsModalProps> = ({courseId, courseNumber, formikProps, bookingsOfCourse, lessonsAreChanged}) => {
    const [open, setOpen] = useState(false);
    const [openDocumentation, setOpenDocumentation] = useState(false);

    const ButtonChanged = () => {
        return (
            <Button size="small" className={css.changedButton} block onClick={() => setOpen(true)}>
                {"Buchungen an die geänderten Termine anpassen"}
            </Button>
        );
    };

    const ButtonNotChanged = () => {
        return (
            <Button size="small" className={css.notChangedButton} block onClick={() => setOpen(true)}>
                {"Buchungen anpassen"}
            </Button>
        );
    };

    if (!open) {
        return (
            <div className={css.changedContainer} style={{gridColumn: "1 / -1"}}>
                {lessonsAreChanged ? <ButtonChanged /> : <ButtonNotChanged />}
            </div>
        );
    }

    return (
        <Modal
            title={
                <ModifyBookingsModalTitle
                    courseNumber={courseNumber}
                    allowMolliePayment={formikProps.values.allowMolliePayment === true}
                    mollieOptional={formikProps.values.mollieOptional === true}
                    onInfoClick={() => setOpenDocumentation(!openDocumentation)}
                />
            }
            open={true}
            onOk={() => setOpen(false)}
            onCancel={() => setOpen(false)}
            width="80%"
            style={{top: 100}}
            bodyStyle={{height: "75vh", paddingTop: 0}}
        >
            <ModifyBookingsDocumentation asModal={true} open={openDocumentation} onClose={() => setOpenDocumentation(false)} />
            <ModalContainer courseId={courseId} formikProps={formikProps} bookingsOfCourse={bookingsOfCourse} />
        </Modal>
    );
};

export default memo(ModifyBookingsModal);
